<template>
  <div>
    <div class="areaItem" v-for="(item, ind) in orderList" :key="item.gameId">
      <div class="item" @click="goOrder(item, ind)">
        <img v-lazy="item.gameIconUrl" :key="item.gameIconUrl" alt="">
        <p>{{item.gameName}}</p>
      </div>
      <div :class="item.button=='已预约'?'button ordered':'button order'" @click="showmask($event,item.gameId)" :ref="item.gameId">{{item.button}}</div>
    </div>
  </div>
</template>
<script>
import config from '@/../config'
export default {
  props:['orderList'],
  methods:{
    goOrder(game, ind){
      this.$parent.enterDetails(game, ind);
      var data = location.href.split("?");
      window.location.href = `${config.SERVER_TEMP}/gameserv/GameDetail/detail.html?gameId=${gameId}&${data[1]}`;
      // if(this.$route.path == '/game/gameorder'){
      //   let url = window.location.href  
      //   url = url.slice(0,url.indexOf('.app'))
      //   window.location.href = `${url}.fw.233xyx.com/active.modal/#/newsongsong?id=${gameId}`
      // }
    },
    showmask(event,gameId){
      this.$parent.showmask(event, gameId);
    }
  }
}
</script>
<style lang="less" scoped>
.areaItem {
  width: 0.76rem;
  height: 1.26rem;
  margin-right: 0.12rem;
  margin-bottom: 0.17rem;
  float: left;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .item{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  img{
    width:0.63rem;
    height:0.63rem;
    border-radius: 0.13rem;
  }
  p{
    width: 100%;
    font-size:0.14rem;
    font-weight:400;
    line-height:0.19rem;
    margin-top: 0.08rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:nth-child(4n){
    margin-right: 0;
  }
  .button{
    width: .6rem;
    height: .28rem;
    line-height: .28rem;
    font-size: .15rem;
    border-radius: .14rem;
    margin-top: .08rem;
  }
  .order{
    background: #e5f7eb;
    color: #00B83D;
  }
  .ordered{
    background: #CCCCCC;
    color: #fff;
  }
}
</style>